module.exports = __webpack_public_path__ + "images/Nutanix-b3f9e0.png";